import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { TripDayInfo } from './useTripDayInfos'

interface UpdateTripDayInfoParams {
	tripId: string
	dayIndex: number
	data: {
		name?: string | null
		note?: string | null
		isSkipped?: boolean
	}
}

export const useUpdateTripDayInfo = () => {
	const queryClient = useQueryClient()

	return useMutation<TripDayInfo, Error, UpdateTripDayInfoParams>({
		mutationFn: async ({ tripId, dayIndex, data }) => {
			const response = await api.patch<TripDayInfo>(
				`/trips/${tripId}/tripDayInfo/${dayIndex}`,
				data,
			)
			return response.data
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: queryKeys.tripDayInfos(variables.tripId) })
		},
	})
}
